<template>
    <section class="espacos-module">
        <!-- Loading -->
        <loading />

        <div class="icon-text-wrapper mb-tablet-only">
            <p @click="showSidebarMenu()" role="button" class="turnback">
                Menu
            </p>
        </div>

        <!-- Module Actions -->
        <module-action
            :csrftolken="csrftolken"
            :alldata="moduledata"
            @dynamic-data="getDynamicDataFromModuleAction($event)"
            :orderurl="moduleorder"
            :searchurl="modulesearch"
            classname="espacos-module-action"
            :idname="`${modulename}_header`"
            :modulename="`${modulename}`"
            searchplaceholder="search by id or location"
            :createlink="modulecreate"
            subheaderstring="Cria e gere os teus espaços"
            mobileindicatename="officescreate"
        >
            <template #custom_action> </template>
        </module-action>

        <!-- Content -->
        <template v-if="Object.values(allData).length > 0">
            <div class="table-scroll-wrapper desktop-only">
                <!-- Page List Render-->
                <table-element
                    :classname="['table-striped', 'espacos-content-table']"
                >
                    <!-- THead -->
                    <template #thead>
                        <tr>
                            <th scope="col">
                                <div class="id-header">
                                    <p
                                        class="color-text-body strong-400"
                                        style="border: none"
                                    >
                                        ID
                                    </p>
                                </div>
                            </th>
                            <th scope="col">
                                <p class="strong-600 color-text-body">Nome</p>
                            </th>
                            <th scope="col">
                                <p class="color-text-body strong-400">Estado</p>
                            </th>
                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Localidade
                                </p>
                            </th>
                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Responsável
                                </p>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Categorias
                                </p>
                            </th>
                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Accessorios
                                </p>
                            </th>
                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Criado em:
                                </p>
                            </th>
                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Última edição
                                </p>
                            </th>
                            <th scope="col">
                                <div class="action-header">
                                    <p class="color-text-body strong-400">
                                        Ações
                                    </p>
                                </div>
                            </th>
                        </tr>
                    </template>

                    <!-- Tbody -->
                    <template #tbody>
                        <tr
                            v-for="(value, index) in allData"
                            :key="value.id"
                            :data-referindex="index"
                            :data-id="value.id"
                        >
                            <th scope="row">
                                <div class="same-height id-body">
                                    <p class="strong-400">{{ value.id }}</p>
                                </div>
                            </th>

                            <td>
                                <div class="same-height">
                                    <div>
                                        <p class="strong-600">
                                            {{ value.name }}
                                        </p>
                                        <p class="caption-log color-text-body">
                                            {{ value.value }}
                                        </p>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <div
                                        :class="`${value.active.toLowerCase()}-status`"
                                    >
                                        <span class="status-circle"></span>
                                        <p>{{ value.active }}</p>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p>{{ value.location_name }}</p>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p>{{ value.user_name }}</p>
                                </div>
                            </td>

                            <td class="multiple-words-wrapper">
                                <div class="multiple-words-width">
                                    <p>{{ value.category_id }}</p>
                                </div>
                            </td>

                            <td class="multiple-words-wrapper">
                                <div class="multiple-words-width">
                                    <p>{{ value.accessorie_id }}</p>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p>{{ value.created_at }}</p>
                                </div>
                            </td>

                            <td>
                                <div class="same-height">
                                    <p>{{ value.updated_at }}</p>
                                </div>
                            </td>

                            <td>
                                <div class="buttons-wrapper same-height">
                                    <div
                                        role="button"
                                        type="button"
                                        class="btn-edit"
                                        :data-referindex="index"
                                        :data-id="value.id"
                                        data-action="edit"
                                        data-mobileindicate="officesshow"
                                        @click="buttonActions($event)"
                                    >
                                        <span
                                            data-mobileindicate="officesshow"
                                            class="content-icon"
                                        ></span>
                                    </div>
                                    <div
                                        role="button"
                                        type="button"
                                        class="btnactive"
                                        :data-referindex="index"
                                        :data-id="value.id"
                                        data-action="active"
                                        :data-active="value.active"
                                        @click="buttonActions($event)"
                                    >
                                        <span
                                            :class="
                                                value.active === 'Ativo'
                                                    ? 'content-icon-on'
                                                    : 'content-icon-off'
                                            "
                                        >
                                            <span class="content-icon"></span>
                                        </span>
                                    </div>
                                    <div
                                        role="button"
                                        type="button"
                                        class="btn-remove btnremove"
                                        :data-referindex="index"
                                        :data-id="value.id"
                                        data-action="remove"
                                        @click="buttonActions($event)"
                                    >
                                        <span class="content-icon"></span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </table-element>
            </div>

            <!-- Mobile Card List Render -->

            <div class="espacos-mobile-section mobile-only">
                <template v-for="(value, index) in allData" :key="value.id">
                    <card-element
                        classname="espacos"
                        :index="index"
                        :id="value.id"
                    >
                        <template #cardheadercontent>
                            <div class="header-text-content">
                                <div class="espacos-name strong-600">
                                    {{ value.name }}
                                </div>

                                <div class="caption-lg color-text-body">
                                    {{ value.value }}
                                </div>
                            </div>
                            <div class="header-buttons-content">
                                <div
                                    role="button"
                                    type="button"
                                    class="btn-edit"
                                    :data-referindex="index"
                                    :data-id="value.id"
                                    data-action="edit"
                                    data-mobileindicate="officesshow"
                                    @click="buttonActions($event)"
                                >
                                    <span
                                        data-mobileindicate="officesshow"
                                        class="content-icon"
                                    ></span>
                                </div>
                                <div
                                    role="button"
                                    type="button"
                                    class="btnactive"
                                    :data-referindex="index"
                                    :data-id="value.id"
                                    data-action="active"
                                    :data-active="value.active"
                                    @click="buttonActions($event)"
                                >
                                    <span
                                        :class="
                                            value.active === 'Ativo'
                                                ? 'content-icon-on'
                                                : 'content-icon-off'
                                        "
                                    >
                                        <span class="content-icon"></span>
                                    </span>
                                </div>
                                <div
                                    role="button"
                                    type="button"
                                    class="btn-remove btnremove"
                                    :data-referindex="index"
                                    :data-id="value.id"
                                    data-action="remove"
                                    @click="buttonActions($event)"
                                >
                                    <span class="content-icon"></span>
                                </div>
                            </div>
                        </template>

                        <template #cardbodycontent>
                            <div class="item-wrapper">
                                <p class="color-text-body caption-lg">
                                    Criado em:
                                </p>
                                <p class="black">
                                    {{ value.created_at }}
                                </p>
                            </div>

                            <div class="item-wrapper">
                                <p class="color-text-body caption-lg">
                                    Última edição:
                                </p>
                                <p class="black">
                                    {{ value.updated_at }}
                                </p>
                            </div>

                            <div class="item-wrapper">
                                <p class="color-text-body caption-lg">Ativo</p>
                                <div
                                    :class="`${value.active.toLowerCase()}-status`"
                                >
                                    <span class="status-circle"></span>
                                    <p class="caption-lg">{{ value.active }}</p>
                                </div>
                            </div>
                        </template>
                    </card-element>
                </template>
            </div>

            <!-- Pagination active -->
            <pagination
                :totalpages="parseInt(totalpages)"
                :firstpageurl="firstpage"
                :otherpagesurl="filePageUrl"
                modulename="offices"
            />
        </template>

        <!-- Back To Top -->
        <back-to-top :idhref="`${modulename}_header`" />

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>

<script>
import fetchData from "../../../fetchData";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import Table from "./../../elements/TableElement.vue";
import Pagination from "./../../elements/PaginationElement.vue";
import BackToTop from "./../../elements/BackToTopElement.vue";
import ModuleAction from "./../../elements/ModuleActionElementNew.vue";
import Modal from "./../../elements/ModalElement.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import CardElement from "./../../elements/CardElement.vue";
import responseMessage from "./../../../responseMessage.js";

("use strict");

export default {
    name: "OfficesAdmin",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        adminurl: {
            type: String,
            required: true,
        },
        modulesearch: {
            type: String,
            required: true,
        },
        moduleorder: {
            type: String,
            required: true,
        },
        modulefilter: {
            type: String,
            required: true,
        },
        modulecreate: {
            type: String,
            required: true,
        },
        moduleremove: {
            type: String,
            required: true,
        },
        totalpages: {
            type: String,
            required: true,
        },
        firstpage: {
            type: String,
            required: true,
        },
        modulename: {
            type: String,
            required: true,
        },
        moduleactive: {
            type: String,
            required: false,
        },
        moduleurlbase: {
            type: String,
            required: true,
        },
    },
    data: () => {
        return {
            allData: {},
            moduleshow: "",
            modaltitle: "",
            modaldescription: "",
            modaloptions: {},
            activeclass: "d-flex",
            filePageUrl: "",
            responseTimeOut: 5000,
        };
    },
    created() {
        //Set Review Data
        this.allData = JSON.parse(this.moduledata);

        //Set Review Form Show Url
        this.moduleshow = this.adminurl + `${this.moduleurlbase}/show=`;

        //Set Review Page Url
        this.filePageUrl = this.firstpage + "/page=";
    },
    mounted() {},
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        resumeMessage(text, limit, divisor) {
            //console.log(text);
            if (text !== undefined) {
                let resume =
                    text.length > limit
                        ? `${text.substr(
                              0,
                              Math.round(text.length / divisor)
                          )}...`
                        : text;

                return resume;
            }
        },
        getDynamicDataFromModuleAction(dynamicData) {
            //Set Dynamic Data when clean search input
            if (
                dynamicData !== undefined &&
                typeof dynamicData === "object" &&
                Object.values(dynamicData).length > 0
            ) {
                //Get Default Module Data
                this.allData = dynamicData;
            }
        },
        buttonActions(element) {
            //let referindex = element.currentTarget.getAttribute('data-referindex');
            let action = element.currentTarget.getAttribute("data-action");

            //Data Form
            let dataForm = {
                id: element.currentTarget.getAttribute("data-id"),
                action: action,
            };

            //Set Action bu button
            switch (action) {
                //Edit
                case "edit":
                    //window.location.replace(this.moduleshow + dataForm.id);

                    defaultWebsite.primarySidebarConditional(
                        element,
                        "mobileconditional",
                        dataForm.id
                    );

                    break;

                //Active
                case "active":
                    //Set Active Conditional
                    dataForm.active =
                        element.currentTarget.getAttribute("data-active");

                    //Remove routine
                    this.actionsData(dataForm, action);

                    break;

                //Remove
                case "remove":
                    //Remove routine
                    this.actionsData(dataForm, action);

                    break;
            }
        },
        showModal(element, classname) {
            //Set Modal Data
            this.modaltitle = element.name;
            this.modaldescription = element.description;
            this.modaloptions = element.options;

            //Show Modal
            $(`.${classname}`).modal("show");

            return;
        },
        hideModal(classname) {
            //Hide Modal
            $(`.${classname}`).modal("hide");

            return;
        },
        actionsData(data, action) {
            //Disabled Button
            document
                .querySelector(`.btn${data.action}`)
                .setAttribute("disabled", true);

            //Default Variables
            let message = "";
            let url = "";
            let method = "";

            //Get Conditionals for each Action
            switch (action) {
                //Active
                case "active":
                    message =
                        "Deseja prosseguir com a ativação ou desativação ?";
                    url = this.moduleactive;
                    method = "PATCH";

                    break;

                //Remove
                case "remove":
                    message = `Favor confirmar a exclusão do id nº ${data.id} ?`;
                    url = this.moduleremove;
                    method = "DELETE";

                    break;
            }

            //Confirm Message
            let confirmMessage = message;

            //Confirm Remove
            let confirmRemove = confirm(confirmMessage);

            if (!confirmRemove) {
                //Enabled Button
                document
                    .querySelector(`.btn${data.action}`)
                    .removeAttribute("disabled");

                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            let response = fetchData.structureTosendData(
                url,
                data,
                this.csrftolken,
                method
            );

            //Check Promisse
            response
                .then((value) => {
                    //Enabled Button
                    document
                        .querySelector(`.btn${data.action}`)
                        .removeAttribute("disabled");

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Set Att Data
                    if (value.hasOwnProperty("attData")) {
                        //Get Module Data
                        this.allData = value.attData;
                    }
                })
                .catch((error) => {
                    //Enabled Button
                    document
                        .querySelector(`.btn${data.action}`)
                        .removeAttribute("disabled");

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedAllData() {
            return this.allData;
        },
    },
    watch: {
        computedAllData() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        tableElement: Table,
        pagination: Pagination,
        backToTop: BackToTop,
        moduleAction: ModuleAction,
        modal: Modal,
        cardElement: CardElement,
    },
};
</script>
